
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';
import { Switch } from '@/components/ui/switch';
import { Separator } from '@/components/ui/separator';
import { HeaderSettings, FooterSettings, WatermarkSettings } from '@/utils/pdf-templates/types';

interface Props {
    header: HeaderSettings;
    footer: FooterSettings;
    watermark: WatermarkSettings;
    onHeaderChange: (val: HeaderSettings) => void;
    onFooterChange: (val: FooterSettings) => void;
    onWatermarkChange: (val: WatermarkSettings) => void;
}

export function HeaderFooterSettings({ header, footer, watermark, onHeaderChange, onFooterChange, onWatermarkChange }: Props) {
    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="space-y-4">
                <h4 className="font-semibold text-sm">الغلاف</h4>
                <div className="flex items-center justify-between">
                    <Label>إظهار الغلاف</Label>
                    <Switch checked={header.showCover} onCheckedChange={(v) => onHeaderChange({ ...header, showCover: v })} />
                </div>
                {header.showCover && (
                    <div>
                        <div className="flex justify-between mb-2">
                            <Label>ارتفاع الغلاف</Label>
                            <span className="text-sm text-muted-foreground font-mono">{header.coverHeight}px</span>
                        </div>
                        <Slider min={200} max={600} step={10} value={[header.coverHeight]} onValueChange={([v]) => onHeaderChange({ ...header, coverHeight: v })} />
                    </div>
                )}
            </div>

            <Separator />

            {/* Footer */}
            <div className="space-y-4">
                <h4 className="font-semibold text-sm">التذييل</h4>
                <div className="flex items-center justify-between">
                    <Label>إظهار التذييل</Label>
                    <Switch checked={footer.showFooter} onCheckedChange={(v) => onFooterChange({ ...footer, showFooter: v })} />
                </div>
                <div className="flex items-center justify-between">
                    <Label>إظهار QR Code</Label>
                    <Switch checked={footer.showQr} onCheckedChange={(v) => onFooterChange({ ...footer, showQr: v })} />
                </div>
                <div className="flex items-center justify-between">
                    <Label>إظهار رقم الصفحة</Label>
                    <Switch checked={footer.showPageNumber} onCheckedChange={(v) => onFooterChange({ ...footer, showPageNumber: v })} />
                </div>
                <div>
                    <Label className="mb-2 block">نص تذييل مخصص</Label>
                    <Input value={footer.customText} onChange={(e) => onFooterChange({ ...footer, customText: e.target.value })} placeholder="نص مخصص في التذييل..." />
                </div>
            </div>

            <Separator />

            {/* Watermark */}
            <div className="space-y-4">
                <h4 className="font-semibold text-sm">العلامة المائية</h4>
                <div>
                    <Label className="mb-2 block">نص العلامة المائية</Label>
                    <Input value={watermark.text} onChange={(e) => onWatermarkChange({ ...watermark, text: e.target.value })} placeholder="مثال: سري - للعرض فقط" />
                </div>
                {watermark.text && (
                    <>
                        <div>
                            <div className="flex justify-between mb-2">
                                <Label>الشفافية</Label>
                                <span className="text-sm text-muted-foreground font-mono">{Math.round(watermark.opacity * 100)}%</span>
                            </div>
                            <Slider min={0.02} max={0.3} step={0.02} value={[watermark.opacity]} onValueChange={([v]) => onWatermarkChange({ ...watermark, opacity: v })} />
                        </div>
                        <div>
                            <div className="flex justify-between mb-2">
                                <Label>الحجم</Label>
                                <span className="text-sm text-muted-foreground font-mono">{watermark.size}px</span>
                            </div>
                            <Slider min={20} max={120} step={5} value={[watermark.size]} onValueChange={([v]) => onWatermarkChange({ ...watermark, size: v })} />
                        </div>
                        <div>
                            <div className="flex justify-between mb-2">
                                <Label>زاوية الدوران</Label>
                                <span className="text-sm text-muted-foreground font-mono">{watermark.rotation}°</span>
                            </div>
                            <Slider min={-90} max={0} step={5} value={[watermark.rotation]} onValueChange={([v]) => onWatermarkChange({ ...watermark, rotation: v })} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
